const findComponent = (components, types, short = false) => {
  const component = components.find(c => types.some(type => c.types.includes(type)));
  if (!component) return '';
  return short ? component.short_name : component.long_name;
};

export const parsePlace = (place, prediction) => {
  const components = place.address_components || [];
  return {
    formatted_address: place.formatted_address,
    display_name: prediction.structured_formatting?.main_text || place.name,
    name: prediction.structured_formatting?.main_text || place.name,
    coordinates: {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    },
    city: findComponent(components, ['locality', 'sublocality', 'administrative_area_level_3']),
    province: findComponent(components, ['administrative_area_level_1'], true)
  };
};

export const buildLocationFromGeocode = (result, latitude, longitude) => {
  const components = result.address_components || [];
  return {
    formatted_address: result.formatted_address,
    name: 'Current Location',
    coordinates: { lat: latitude, lng: longitude },
    city: findComponent(components, ['locality', 'sublocality']),
    province: findComponent(components, ['administrative_area_level_1'], true)
  };
};
